import * as PIXI from 'pixi.js';
import GameConfig from '../GameConfig';
import State from './State';
import {Countdown} from '../Countdown';
import {Loc} from 'src/common/map/Location';
import {clamp} from '../../utils';
import {CannonCursor} from '../CannonCursor';
import {PlaceCannon} from '../actions/PlaceCannon';
import {pointerRenderer} from 'src/Pixi/PointerRenderer';
import {gridRenderer} from 'src/Pixi/map/GridRenderer';

import Point = PIXI.Point;

class PlaceState extends State {
    private tile: Point = new Point();
    private countdown: Countdown;
    private cursor: CannonCursor = new CannonCursor();

    public start(): void {
        this.game.updateAlivePlayers();
        this.game.updateCannonPlaceCounts();
        this.countdown = new Countdown(10, 'Place Cannons');
        this.countdown.start();
        pointerRenderer.setPointerType('pointer');
        gridRenderer.showForMap(this.game.map);
    }

    public finish(): void {
        this.countdown.finish();
        this.cursor.hide();
        this.controller.showCursor();
        gridRenderer.hide();
    }

    public tick(): void {
        this.countdown.tick();

        if (this.player().isAlive) {
            this.cursor.updateRemainingCount(this.cannonsLeft());

            if (this.cursor.canPlace && this.cannonsLeft() === 0) {
                this.cursor.hide();
                this.controller.showCursor();
            }
        } else {
            if (!this.controller.state.hasAskedToSpectate) {
                this.controller.askToSpectate();
            }
        }
    }

    public onMouseMove(pos: Point): void {
        if (!this.player().isAlive) return;
        if (this.cannonsLeft() === 0) return;

        this.tile = this.tilePosition(pos);
        this.cursor.updatePosition(this.tile, this.game.map, this.game.index);
        this.controller.hideCursor();
    }

    private tilePosition({x, y}: Loc): Point {
        const tileX = clamp(Math.floor(x / GameConfig.tileSize), 0, this.game.map.width - 2);
        const tileY = clamp(Math.floor(y / GameConfig.tileSize), 0, this.game.map.height - 2);
        return new Point(tileX, tileY);
    }

    public onMouseClick(_e: Point): void {
        if (!this.player().isAlive || this.cannonsLeft() === 0 || !this.cursor.canPlace) return;
        new PlaceCannon(this.game).byClient(this.tile);
    }

    private cannonsLeft(): number {
        return this.game.currentPlayer.cannonsLeftToPlace;
    }
}

export default PlaceState;



// WEBPACK FOOTER //
// ./src/game/states/PlaceState.ts